

















































































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { IUser } from '@/store/modules/views/user/states'
import { IRole } from '@/store/modules/views/role/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import {IRegisterFormData} from '@/store/modules/views/register/states'
import { ICenter } from '@/store/modules/views/center/states'

@Component
export default class EditUserDialog extends VueExtendedBaseComponent {

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get isDisabledCenter() {
    return !(this.role && this.role.requireCenter)
  }

  @Getter('components/prefixNames')
  private prefixNames: string[]

  private prefix: string

  get editUserDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editUserAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }


  get roleLists() {
    return this.roleItemLists
  }

  get centerList() {
    if (this.profileData.role.name === 'ผู้ดูแลระบบ') {
      return this.centerLists
    } else {
      return this.profileData.center
    }
  }

  get validateInput() {
    return this.nameValidate(this.firstname)
      && this.nameValidate(this.lastname)
      // && this.cidValidate()
      && this.phoneValidate()
  }

  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private user!: IUser & {permissions: string[], accounts: string[]}
  private loading = false
  private date = null
  private menu = false
  private valid = false
  private urlUser = ''
  private address = ''
  private activePicker = null

  @Action('role/getRoleList')
  private getRoleList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  @Action('center/getCenterList')
  private getCenterList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void



  @Getter('role/roleLists')
  private roleItemLists!: IRole[]

  @Getter('map/getMapUserLocation')
  private userMapData!: { lat: number; lon: number, address: string }

  @Getter('center/itemLists')
  private centerLists!: ICenter[]

  @Getter('userprofile/getProfile')
  private profile!: any

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get userProfile() {
    return this.profile
  }

  get age() {
    const age = this.diffDate(this.date)
    const year = Math.floor(age)
    const month = Math.floor((age - year) * 12)
    return `อายุ ${year ? year + 'ปี ' : ''}${month}เดือน`
  }

  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private firstname = ''
  private lastname = ''
  private centerId = ''
  private phone = ''
  private cid = ''
  private profileData: any = {}
  private map = {
    lat: 0,
    lon: 0,
  }
  private filters = {}
  private location: IRegisterFormData['address'] = {address: ''}
  private role: IRole = null
  private userPermissionitems!: string[]
  private phoneRules = [
    (phone: string) => !!phone || 'กรุณากรอกหมายเลขโทรศัพท์',
    (phone: string) => this.validateInputFromType('phone', phone),
  ]
  private cidRules = [
    (cid: string) => !!cid || 'กรุณากรอกหมายเลขบัตรประจำตัวประชาชน',
    (cid: string) => this.validateInputFromType('cid', cid),
  ]
  public async created() {
    this.map = this.user.map
    this.location = this.user.address || {address: ''}
    this.address = this.user.address.address || ''
    this.prefix = this.user.prefix || ''
    this.firstname = this.user.firstname || ''
    this.lastname = this.user.lastname || ''
    this.cid = this.user.idCard || ''
    this.phone = this.user.phone || ''
    this.date = this.user.birthdate || null
    this.userPermissionitems = this.user.permissions
    this.profileData = this.userProfile || {}
    this.prefix = this.prefix || ''

    this.role = _.find(this.roleItemLists, (role) => role._id === this.user.roleId)
    this.centerId = this.user.centerId || ''
  }

  private cidValidate() {
    return /^[0-9]{13}$/.test(
        this.cid) || false
  }

  private phoneValidate() {
    return /^(0|66|\+66)[1-9]{1}[0-9]{7,8}$/.test(
        this.phone) || false
  }

  private changeDateType() {
    this.menu = false
  }
  private async editUserAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      const userData = {
        edit: {
          prefix: this.prefix,
          firstname: this.firstname,
          lastname: this.lastname,
          phone: this.phone,
          birthdate: this.date,
          map: this.map,
          address: {address: this.address, ...this.location},
          roleId: this.role._id,
          centerId: this.centerId,
        },
      }
      try {
        await Promise.all([
          HttpRequestServiceWithToken.putByLevel(`${process.env.VUE_APP_API_URL}/v1`,
              `user/${this.user._id}`,
              userData.edit,
          ),
        ])
        this.updateSnackbar({txt: 'แก้ไขผู้ขอรับบริการสำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        await this.callback()
        this.loading = false
        return false
      }
    } else {
      return false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  @Watch('menu')
  private birthdate(val) {
    if (val) {
      setTimeout(() => (this.activePicker = 'YEAR'))
    }
  }
}
